<template>
  <div>
    <div>
      <pre>
            Build_{{BUILD_NUMBER}}, {{GIT_VERSION}}, {{ env.NODE_ENV }}, {{ env.VUE_APP_API }}
      </pre>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      env: process.env,
      COMMITHASH: COMMITHASH,
      GIT_VERSION: GIT_VERSION,
      BUILD_NUMBER: BUILD_NUMBER,
      user: null,
      p24Result: null,
      p24PaymentRedirUrl: null
    };
  },

  methods: {}
};
</script>

<style scoped>
.debug {
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: rgba(196, 197, 227, 0.975);
  font-style: normal;
  font-size: 12px;
  font-family: courier;
  padding: 3px;
}
</style>